// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  authService: 'oidc.okta',
  firebase: {
    apiKey: 'AIzaSyAFzB9A12qnxr2Ba7mL7HIz_d5CakZX-kw',
    authDomain: 'dev-coach.waldenu.edu',
    databaseURL: 'https://walden-doctoral-res-coach-dev.firebaseio.com',
    projectId: 'walden-doctoral-res-coach-dev',
    storageBucket: 'walden-doctoral-res-coach-dev.appspot.com',
    messagingSenderId: '1002126932015',
    appId: '1:1002126932015:web:b605d8ae2ff9c9d343aeda',
    measurementId: 'G-3506C680L7'
  },
  baseUrl: 'https://qa-apigateway.adtalem.com',
  subscriptionKey: '62d1c043792444079f93ebcfd1e6ca3b',
  authenticationType: 'System',
  cloudFunction: {
    baseUrl: 'https://dev-coach.waldenu.edu/v1/rest',
  },
  appName: 'STAFF'
};


